<script lang="ts">
  import type { TabData } from './wrappers';

  export let isSelected: boolean;
  export let tabData: TabData;
  export let disabled: boolean = false;

  const selectedColor = '#000';
  const defaultColor = '#66857D';

  $: color = isSelected ? selectedColor : defaultColor;
  $: borderColor = isSelected ? selectedColor : 'transparent';
</script>

<button
  class="w-full flex font-bold whitespace-nowrap items-center justify-center border-b-4 pb-4 pt-4 gap-x-2 px-1 duration-200"
  style:border-color={borderColor}
  {disabled}
  on:click
>
  <div class="hidden md:block">
    {#if tabData.icon}
      <svelte:component this={tabData.icon} {color} />
    {/if}
  </div>

  <p class:black={isSelected} class="text-sm md:text-base" class:grey={!isSelected}>
    {tabData.title}
  </p>
</button>

<style lang="postcss">
  .grey {
    @apply text-garden-grey-500;
  }

  .black {
    @apply text-black;
  }
</style>
